import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
    import { useI18n } from '@/i18n'
    
export default /*#__PURE__*/_defineComponent({
  __name: 'EulaText',
  setup(__props) {

    const { locale } = useI18n();
    const language = ref(locale.value === 'sv' ? 'sv' : 'en');
    const resize = computed(() => window.innerHeight / 1.7);

return { __sfc: true,locale, language, resize }
}

})